import { rpcDefinition } from "@redotech/redo-merchant-fulfillment-rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoOutboundLabelsRpcContract } from "./rpc-contract.generated";

export function createRedoOutboundLabelsRpcClient(
  options: ClientOptions<RedoOutboundLabelsRpcContract>,
): RedoOutboundLabelsRpcContract {
  return createRpcContractClient<RedoOutboundLabelsRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoOutboundLabelsRpcClient = RedoOutboundLabelsRpcContract;
